import React, {useState, useRef, useEffect} from 'react';
import { Button, Form, Image } from 'react-bootstrap';
import { store } from 'react-notifications-component';
import '../index.css'
import PDFJPG from '../../../Images/pdf.jpg'
import Backend from '../../../Backend';
import Connection from '../../../Calls';
import FPassport from '../../../Images/kyc/f_passport.svg';
import FIdFront from '../../../Images/kyc/f_id_front.svg';
import FiDBack from '../../../Images/kyc/f_id_back.svg';
import OtherFile from '../../../Images/kyc/other_files.svg';
import FSelfieId from '../../../Images/kyc/f_id_selfie.svg';
import FUtilityBill from '../../../Images/kyc/f_utility_bill.svg';
import Argentina from '../../../Images/kyc/Argentina.svg';
import Bolivia from '../../../Images/kyc/Bolivia.svg';
import Colombia from '../../../Images/kyc/Colombia.svg';
import Ecuador from '../../../Images/kyc/Ecuador.svg';
import Peru from '../../../Images/kyc/Peru.svg';

const InputFile = props => {
    const fileInput = useRef();
    const [image, setLocalImage] = useState({});
    const lang = localStorage.getItem("lan");

    let imagePlaceholder = {
        f_passport: FPassport,
        f_id_front: FIdFront,
        f_id_back: FiDBack,
        f_rfc: OtherFile,
        f_id_selfie:FSelfieId,
        f_utility_bill: FUtilityBill,
        f_public_register: OtherFile,
        f_rfc_rep: OtherFile,
        f_constitutive_act: OtherFile,
        f_last_constitutive_act: OtherFile,
        f_bank_bill: OtherFile
    }

    const dynamicPlaceholderRfc = () => {
        const {country, countryRep, countryInc} = props;
        if (props.name === 'f_rfc'){     
            switch(country){
                case 'Argentina':
                    return Argentina
                case 'Bolivia, Plurinational State of':
                    return Bolivia
                case 'Colombia':
                    return Colombia
                case 'Ecuador':
                    return Ecuador
                case 'Peru':
                    return Peru
                default:
                    return OtherFile
            }
        } else{
        return imagePlaceholder[props.name]
        } 
    }


    useEffect(() => {
        if (props.cleanInputFile == false) {
            getImages(props)
        }
    }, [props.cleanInputFile]);
    
    useEffect(() => {
        if(props.setImage)
            props.setImage(image)
    }, [image]);

    const getImages = ({name}) => {
        let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
        navigator.geolocation.getCurrentPosition((success, error, options) => {
            latitude = success.coords.latitude;
            longitude = success.coords.longitude
        });
        result = latitude + longitude;
        Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
            Backend.get_image(localStorage.getItem('email'), localStorage.getItem('token'), name, response.payload.r01, response => {
                if(response.status.code === '0'){
                        setLocalImage({
                            base64: response.payload.img_b64,
                            base64Type:  response.payload.file_type,
                            img: "data:image/png;base64,"+response.payload.img_b64,
                            correctUpload:false,
                            name: response.payload.file_name,
                        })
                }
            })
        })
    }

    const addNotification = (status,msg,type) => {
        store.addNotification({
          title: status,
          message: msg,
          type: type,
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 2500,
            onScreen: true
          }
        });
    }

    const _onChangeImage = () => {

        var file = fileInput.current.files[0];
        var fileType = file.name.split(".")[file.name.split(".").length-1].toLowerCase()
        var reader = new FileReader();
        reader.readAsDataURL(file);
        if (file.size > 8000000) {
            document.getElementById("img").value = "";
            addNotification("Error!","Image exceeds 8MB.","danger");
        }else if (fileType != 'jpeg' && fileType != 'png' && fileType != 'jpg' && fileType != 'pdf'){
            document.getElementById("imgIdFront").value = "";
            addNotification("Error!", "Only .jpeg .png or .pdf files are acceptable","danger");
        }else {
            reader.onloadend = function (e) {
                var image_split = [reader.result][0];
                setLocalImage({
                    img: [reader.result],
                    base64: image_split.split(",")[1],
                    base64Type: fileType,
                    imgFile: file,
                    imgName: file.name,
                    correctUpload:false
                })
            }.bind(this);
        }
    }

    return (
        <div> 
            <div className={props.className || 'input_files_image'}>
                <div className="container_file_image_display_flex">
                    <div style={{textAlign:'center', height:"100%", display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center'}}>
                        {
                            image.base64 ?
                                <div style={{height:'100%'}}>
                                    {
                                        (image.base64Type == 'pdf')
                                        ?<Image src={PDFJPG} style={{ width: "100%", height: '100%' }} fluid />
                                        :<Image src={image.img} style={{ width: "100%", height: '100%' }} fluid />
                                    }
                                    <div className="container_btnCancel_file">
                                        <Button className="btnCancel" onClick={() => setLocalImage('')}>Cancel</Button>
                                    </div>
                                </div>
                            :
                                <>
                                    <Image src={dynamicPlaceholderRfc()} width={75} height={65} style={{textAlign: 'center'}} />
                                    <Form.Control
                                        style={{ width: "fit-content", fontSize: 12, display:'none' }}
                                        ref={fileInput}
                                        id="img"
                                        type="file"
                                        name="user[image]"
                                        multiple={false}
                                        accept={"image/png, image/jpeg, image/jpg" + (props.noPdf?'':", .pdf")}
                                        size="2000000"
                                        onChange={() => { _onChangeImage() }}
                                    />
                                    <span style={{fontSize: 18, marginTop: 13}}>{props.label}</span>
                                    <p style={{ fontSize:  props.name === 'f_id_back' || props.name === 'f_id_front' ? 12 : 12, textAlign: "center", color: "#959595", margin:'10px', whiteSpace: props.name === 'f_id_back' || props.name === 'f_id_front' ? 'initial' :'pre-wrap' }}>
                                    {
                                        props.name === 'f_id_selfie' ?
                                        (   lang === 'es' ? 'Tómate una fotografía sujetando tu identificación con la mano, debe ser visible tu credencial.'
                                                : 
                                            lang === 'en' ? 'Take a photo of yourself holding your ID card with\nyour hand next to your face. Your ID card must\nbe completely visible.': 
                                        '')
                                        :props.name === 'f_utility_bill'? 
                                        (   lang === 'es' ? 'Debe ser menor a 3 meses de antigüedad.\n(Luz, agua, teléfono fijo, caratula bancaria)'
                                                : 
                                            lang === 'en' ? 'It must be less than 3 months old.\n(Electricity, water, landline telephone, bank card)': 
                                        ''):
                                        (lang === 'es' ? 'Los archivos deben ser .jpeg, .png, .jpg o .pdf,\nno pueden tener más de 8 MB.'
                                            : 
                                        'Files should be .jpeg, .png, .jpg or .pdf,\ncannot be bigger than 8MB.')
                                    }
                                    </p>
                                    <button className="upload-file-btn" style={{width: '70%', marginTop: 15}} onClick={()=>fileInput.current.click()}>
                                        {
                                            lang === 'es' ? "Subir archivo" : "Upload file"
                                        }
                                    </button>
                                </>
                        }
                    </div>
                </div>
            </div>
        </div>
     );
}

export default InputFile;
